import { create } from 'zustand';

type PendingNotifications = {
  notifications: number;
  messages: number;
};

type PendingNotificationsStore = PendingNotifications & {
  hydrate: (s: Partial<PendingNotifications>) => void;
  incNotifications: (by?: number) => void;
  decNotifications: (by?: number) => void;
  resetNotifications: () => void;
  setMessages: (n: number) => void;
  resetMessages: () => void; 
};

export const usePendingNotificationsStore = create<PendingNotificationsStore>((set) => ({
  notifications: 0,
  messages: 0,

  hydrate: (s) => set((prev) => ({ ...prev, ...s })),
  incNotifications: (by = 1) => set((prev) => ({ notifications: Math.max(0, prev.notifications + by) })),
  decNotifications: (by = 1) => set((prev) => ({ notifications: Math.max(0, prev.notifications - by) })),
  resetNotifications: () => set({ notifications: 0 }),
  setMessages: (n) => set({ messages: Math.max(0, n) }),
  resetMessages: () => set({ messages: 0 }),
}));
